import constate from 'constate';
import useUserData from './useUserData';

// These context hooks live in their own module (not the hooks barrel) so
// sibling hooks can consume them without importing the barrel that imports
// them back — that import cycle made vite's module runner serve the barrel's
// half-populated namespace to every consumer of @smartmixin/core (the
// isolate:false vitest flake), and cycle-tolerant resolution is the only
// reason it ever worked under metro/jest.
const [
  UserProvider,
  useUserLanguage,
  useDateTimeConfig,
  useUserEdit,
  useUserLogin,
  useUserLoggedIn,
  useRegistrationHeaders,
  useUserUnits,
  useUserFeelLike,
] = constate(
  useUserData,
  (value) => value.language,
  (value) => value.dateTimeConfig,
  (value) => value.editUserDetails,
  (value) => value.storeLoginDetails,
  (value) => value.isLoggedIn,
  (value) => value.getRegistrationHeaders,
  (value) => value.units,
  (value) => value.userFeelLike,
);

export {
  UserProvider,
  useDateTimeConfig,
  useRegistrationHeaders,
  useUserEdit,
  useUserFeelLike,
  useUserLanguage,
  useUserLoggedIn,
  useUserLogin,
  useUserUnits,
};
